import {createAsyncThunk} from "@reduxjs/toolkit";
import {getCurrentUser} from "services/api";

export const getProfileAction = createAsyncThunk("profile/get", async () => {
  try {
    return await getCurrentUser();
  } catch (e: unknown) {
    throw new Error(e as string);
  }
});